import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import autoBind from 'auto-bind';
import { SemanticToastContainer } from 'react-semantic-toasts';
import { ActionBar } from 'pages/Npwp/ActionBar';
import BusinessesList from 'pages/Npwp/BusinessesList';
import {
  loadNpwpBusinessDetail,
  loadNpwpBusinessList,
} from 'state/npwp/actions';
import BusinessDetailModal from 'pages/Npwp/BusinessDetailModal';

export class NpwpReviewPage extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    const {
      businesses: { filters },
    } = this.props;
    this.onFilterChanged(filters);
  }

  onFilterChanged(filters) {
    const {
      dispatch,
      businesses: {
        data: { size },
      },
    } = this.props;
    dispatch(loadNpwpBusinessList(filters, { page: 1, size }));
  }

  onBusinessListPageChange(page) {
    const {
      dispatch,
      businesses: {
        filters,
        data: { size },
      },
    } = this.props;
    dispatch(loadNpwpBusinessList(filters, { page, size }));
  }

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  onBusinessItemClicked(businessId) {
    const { dispatch } = this.props;
    dispatch(loadNpwpBusinessDetail(businessId));
  }

  render() {
    const {
      businesses: { data, filters, isLoading },
    } = this.props;

    return (
      <>
        <SemanticToastContainer />
        <h1>NPWP Review</h1>
        <br />
        <ActionBar filters={filters} onApplyFilter={this.onFilterChanged} />
        <BusinessesList
          onBusinessItemClicked={this.onBusinessItemClicked}
          isLoading={isLoading}
          onPageChange={this.onBusinessListPageChange}
          data={data}
        />
        <BusinessDetailModal />
      </>
    );
  }
}

const mapStateToProps = state => ({
  ...state.npwp,
});

NpwpReviewPage.propTypes = {
  businesses: PropTypes.shape({
    data: PropTypes.shape({
      list: PropTypes.array.isRequired,
      page: PropTypes.number.isRequired,
      size: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
    }),
    filters: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(NpwpReviewPage);
